<script setup lang="ts">
defineProps<{
  head?: unknown
}>()
</script>

<template>
  <div class="overflow-x-auto">
    <table class="w-full table-fixed border-collapse text-[13px]">
      <thead v-if="$slots.head" class="border-b border-line bg-raised/50">
        <slot name="head" />
      </thead>
      <tbody class="divide-y divide-line">
        <slot />
      </tbody>
    </table>
  </div>
</template>
